module.exports = __webpack_public_path__ + "img/maya-opcion-2.af2a5a45.png";